import * as React from 'react'
import { SVGProps } from 'react'
const SvgRainbowwheel = (props: SVGProps<SVGSVGElement>) => (
  <svg width={18} height={18} viewBox="0 0 18 18" fill="none" {...props}>
    <g clipPath="url(#a)">
      <path
        d="M3.944 3.944 2.482 2.482c3.315-3.315 8.704-3.315 12.019 0l-1.462 1.462c-2.499-2.499-6.579-2.499-9.095 0Z"
        fill="#369E27"
      />
      <path
        d="m14.518 14.518-1.462-1.462a6.475 6.475 0 0 0 0-9.112l1.462-1.462c3.298 3.315 3.298 8.721 0 12.036Z"
        fill="#3E428C"
      />
      <path
        d="m2.482 14.518 1.462-1.462a6.475 6.475 0 0 0 9.112 0l1.462 1.462c-3.315 3.298-8.721 3.298-12.036 0Z"
        fill="#F31316"
      />
      <path
        d="M2.482 14.518c-3.315-3.315-3.315-8.704 0-12.019l1.462 1.462c-2.499 2.499-2.499 6.579 0 9.095l-1.462 1.462Z"
        fill="#D8DD28"
      />
      <path
        d="M2.074 8.5H0C0 3.808 3.808 0 8.5 0v2.074A6.42 6.42 0 0 0 2.074 8.5Z"
        fill="url(#b)"
      />
      <path
        d="M17 8.5h-2.074A6.432 6.432 0 0 0 8.5 2.074V0C13.192 0 17 3.808 17 8.5Z"
        fill="url(#c)"
      />
      <path
        d="M8.5 17v-2.074A6.432 6.432 0 0 0 14.926 8.5H17c0 4.692-3.808 8.5-8.5 8.5Z"
        fill="url(#d)"
      />
      <path
        d="M8.5 17A8.503 8.503 0 0 1 0 8.5h2.074A6.432 6.432 0 0 0 8.5 14.926V17Z"
        fill="url(#e)"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={0}
        y1={4.25}
        x2={8.5}
        y2={4.25}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE600" />
        <stop offset={1} stopColor="#18941D" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={8.5}
        y1={4.25}
        x2={17}
        y2={4.25}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#18941D" />
        <stop offset={1} stopColor="#38318A" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={8.5}
        y1={12.75}
        x2={17}
        y2={12.75}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="red" />
        <stop offset={1} stopColor="#38318A" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={0}
        y1={12.75}
        x2={8.5}
        y2={12.75}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE600" />
        <stop offset={1} stopColor="red" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h17v17H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgRainbowwheel
